import Service from '@ember/service';
import { PanelRequest } from '@square/dashboard-protos/models/squareup/jedi/service';
import JediService from '@banking/ui/services/jedi/jedi';

// eslint-disable-next-line ember/no-classic-classes
export default Service.extend({
  makeGetPanelRequest({
    sessionToken,
    panelToken,
    inputs,
    anonymousToken
  }) {
    const request = PanelRequest.create({
      sessionToken,
      panelToken,
      inputs,
      anonymousToken
    });
    return JediService.getPanel(request);
  }
});